var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "page-wrapper"
  }, [_c('header', [_c('p', [_vm._v("Driver Licence Check")]), _vm._v(" "), (_vm.isLoggedIn && !_vm.isProfileRoute) ? _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("My details")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && _vm.isProfileRoute) ? _c('router-link', {
    attrs: {
      "to": "/consents"
    }
  }, [_vm._v("My approvals")]) : _vm._e()], 1), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', [_vm._v("\n    © " + _vm._s(new Date().getFullYear()) + " Fonix Telematics\n    "), (_vm.isLoggedIn) ? _c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_vm._v("Logout")]) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "version"
  }, [_vm._v(" \\ v" + _vm._s(_vm.version))])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-427a9fc7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = CWKO
// module chunks = 2